// extracted by mini-css-extract-plugin
export default {"container":"QuickAccess_container__hj4jL"};